export const workflowFunctions = Object.freeze({
    string: {
        label: 'String',
        list: ['concat', 'endsWith', 'startsWith', 'includes', 'indexOf', 'match', 'split', 'substring', 'toLowerCase', 'toUpperCase', 'trim']
    },
    number: {
        label: 'Number',
        list: ['isFinite', 'isInteger', 'isNaN', 'toFixed']
    },
    array: {
        label: 'Array',
        list: ['concat', 'every', 'filter', 'find', 'findIndex', 'includes', 'indexOf', 'join', 'map', 'pop', 'push', 'reduce', 'reverse', 'sort', 'some', 'splice']
    }
})
